// extracted by mini-css-extract-plugin
export default {"notificationWrapper":"NotificationToggle_notificationWrapper__O5Xbj"};